// extracted by mini-css-extract-plugin
module.exports = {"xl":"_3b80d6b","l":"_c5b7f8a","m":"_44a0a1c","s":"_f781847","xs":"_2268663","xxl":"_b9fc39b","left":"_e2a6a6e","right":"_b599ae5","center":"_a036773"};